import { render } from "./CardPanel.vue?vue&type=template&id=0bb1f04b&scoped=true&ts=true"
import script from "./CardPanel.vue?vue&type=script&lang=ts"
export * from "./CardPanel.vue?vue&type=script&lang=ts"

import "./CardPanel.vue?vue&type=style&index=0&id=0bb1f04b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb1f04b"]])

export default __exports__